import { createFileRoute } from "@tanstack/react-router";

/**
 * `?month=YYYY-MM` — tháng đang xem (chủ studio chốt "1a" ngày 08/09/2026).
 *
 * Trước đó tháng chỉ nằm trong state của màn, nên đi từ dòng cảnh báo "đơn
 * chưa gán ê-kíp" sang chi tiết đơn rồi bấm quay lại là ô tháng nhảy về tháng
 * hiện tại — phải chọn lại tháng sau MỖI đơn. Đưa lên địa chỉ trang thì quay
 * lại về đúng tháng cũ, và gửi được đường dẫn thẳng tới một tháng cho người
 * khác.
 *
 * Giá trị lạ được THA, không chặn: màn tự rơi về tháng hiện tại. Một địa chỉ
 * gõ sai không đáng để người ta gặp trang lỗi.
 */
type PayrollSearch = { month?: string | undefined };

export const Route = createFileRoute("/_app/payroll/")({
  validateSearch: (search: Record<string, unknown>): PayrollSearch => ({
    month: typeof search.month === "string" ? search.month : undefined,
  }),
});
